module.exports = __webpack_public_path__ + "static/img/3.d759826.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/3.png
// module id = wOQY
// module chunks = 4